import { COLORS } from '@podiumhq/design-system';

const blue = COLORS.blue.base;
const errorRed = COLORS.red.dark;
const placeholderText = COLORS.grey.lighter;
const silver = COLORS.silver.base;
const textColor = COLORS.black.lighter;
const white = COLORS.silver.lightest;

export const FORM_COLORS = {
  blue,
  errorRed,
  placeholderText,
  silver,
  textColor,
  white,
};

const stripeElementBaseStyles = {
  backgroundColor: 'silver.lighter',
  boxSizing: 'border-box',
  color: 'black.lighter',
  height: '48px',
  lineHeight: '48px',
  width: '100%',
};

const stripeElementsBaseErrorStyles = {
  '.StripeElement--error': {
    borderColor: errorRed,
    boxShadow: 'none',
  },

  '.StripeElement--focus': {
    backgroundColor: 'silver.lightest',
    border: `1px solid ${blue}`,
    boxShadow: '0 0 0 2px rgba(76, 118, 224, 0.25)',
  },

  '.StripeElement--invalid': {
    borderColor: errorRed,
    boxShadow: 'none',
  },
};

export const formElementsWithBasicStyles = {
  mb: '24px',
  sx: {
    '.StripeElement': {
      ...stripeElementBaseStyles,
      border: '1px solid',
      borderColor: 'grey.lightest',
      borderRadius: '12px',
      padding: '4px 16px 0 16px',
    },
    ...stripeElementsBaseErrorStyles,
  },
};

export const formElementsWithLabelStyles = {
  mb: '24px',
  sx: {
    '.StripeElement': {
      ...stripeElementBaseStyles,
      backgroundColor: 'silver.lightest',
      border: '1px solid',
      borderColor: 'grey.lighter',
      borderRadius: '4px',
      height: '40px',
      lineHeight: '40px',
      padding: '0 12px',
    },
    ...stripeElementsBaseErrorStyles,
  },
};

export const formElementsWithPlaceholderStyles = {
  mb: '24px',
  sx: {
    '.StripeElement': {
      ...stripeElementBaseStyles,
      borderRadius: '8px',
      padding: '4px 16px',
    },

    ...stripeElementsBaseErrorStyles,
  },
};

export const getFormElementErrorStyles = (error, id) =>
  error
    ? {
        '.chakra-select__icon-wrapper': { right: '30px' },
        '.StripeElement': { borderColor: errorRed },
        [`input[id=${id}]`]: { borderColor: errorRed, pr: '30px' },
        [`select[id=${id}]`]: { pr: '40px' },
      }
    : {};
